import React from "react";
import { useDispatch } from "react-redux";

import { Button } from "../Button";
import { ContainerWrapper, Description, Heading, InfoWrapper } from "./styles";
import { closeActiveModal, setActiveModal } from "../../store/slices/modals";
import { setNewProjectDetails } from "../../store/slices/datasets";

interface AddDatasetsContainerInterface {
  name: string;
  description: string;
  disabledButton: boolean;
}
export const AddDatasetsContainer = ({
  name,
  description,
  disabledButton,
}: AddDatasetsContainerInterface) => {
  const dispatch = useDispatch();

  return (
    <ContainerWrapper>
      <InfoWrapper>
        <Heading>
          {name}
          <Button
            onClick={() => {
              dispatch(setNewProjectDetails({ name, description }));
              dispatch(closeActiveModal());
              dispatch(
                setActiveModal({ id: "datasetLibraryModal", back: true })
              );
            }}
            variant="neutral-color"
            size="xxs"
            name="Edit"
            disabled={disabledButton}
          />
        </Heading>
        <Description>
          {description}
        </Description>
      </InfoWrapper>
    </ContainerWrapper>
  );
};
